<template>
  <div class="form">
    <b-row class="py-0">
      <b-col md="6">
        <b-form-group   :label-cols="3" horizontal :label="index + $lang('姓名(中文)：')">
          <b-form-input
            type="text"
            v-model="value.name"
            name="name"
            :class="errors.has('name') && 'is-invalid'"
            v-validate="{ ...rules.name, required: requiredType }"
            :placeholder="$lang('請輸入名字')"
            :disabled="disabled"
          />
          <b-form-invalid-feedback :state="errors.has('name')">
            {{ errors.first("name") }}
          </b-form-invalid-feedback>
        </b-form-group>
      </b-col>
      <b-col md="6">
        <b-form-group   :label-cols="3" horizontal :label="$lang('姓名(外文)：')">
          <b-form-input
            type="text"
            v-model="value.nameLang"
            name="nameLang"
            :class="errors.has('nameLang') && 'is-invalid'"
            v-validate="{ ...rules.name, required: requiredType }"
            :placeholder="$lang('請輸入名字')"
            :disabled="disabled"
          />
          <b-form-invalid-feedback :state="errors.has('nameLang')">
            {{ errors.first("nameLang") }}
          </b-form-invalid-feedback>
        </b-form-group>
      </b-col>
      <b-col md="6">
        <b-form-group
          horizontal
          :label-cols="3"
          :label="$lang('FIELD_ID_NUMBER_TYPE')"
        >
          <b-input-group>
            <b-form-select
              v-validate="{  required: requiredType }"
              v-model="value.idType"
              name="idType"
              :class="errors.has('idType') && 'is-invalid'"
              :disabled="disabled"
            >
              <option :value="1">{{ $lang("TEXT_ID_TYPE_MACAO") }}</option>
              <option :value="2">{{ $lang("TEXT_ID_TYPE_PASSPORT") }}</option>
              <option :value="3">{{ $lang("TEXT_ID_TYPE_OTHER") }}</option>
            </b-form-select>
            <b-form-invalid-feedback :state="errors.has('idType')">{{
              errors.first("idType")
            }}</b-form-invalid-feedback>
          </b-input-group>
        </b-form-group>
      </b-col>
      <b-col md="6">
        <b-form-group
          horizontal
          :label-cols="3"
          :label="$lang('FIELD_ID_NUMBER')"
        >
          <b-form-input
            type="text"
            v-model="value.idNumber"
            name="idNumber"
            :class="errors.has('idNumber') && 'is-invalid'"
            v-validate="{
              ...rules.idNumber,
              idNumber: value.idType == 1,required: requiredType
            }"
            :placeholder="$lang('請輸入證件號碼')"
            :disabled="disabled"
          />
          <b-form-invalid-feedback :state="errors.has('idNumber')">
            {{ errors.first("idNumber") }}
          </b-form-invalid-feedback>
        </b-form-group>
      </b-col>
      <b-col md="6">
        <b-form-group horizontal :label-cols="3" :label="$lang('出生日期：')">
          <DatePicker
            type="date"
            v-model="value.bornAt"
            name="bornAt"
            size="large"
            :class="errors.has('bornAt') && 'is-invalid'"
            v-validate="{ ...rules.birth, required: true }"
            format="yyyy/MM/dd"
            :disabled="disabled"
          ></DatePicker>
          <b-form-invalid-feedback :state="errors.has('bornAt')">
            {{ errors.first("bornAt") }}
          </b-form-invalid-feedback>
        </b-form-group>
      </b-col>
      <b-col md="6">
        <b-form-group   :label-cols="3" horizontal :label="$lang('手提電話：')">
          <b-form-input
            type="text"
            v-model="value.phone"
            name="phone"
            :class="errors.has('phone') && 'is-invalid'"
            v-validate="'required|mobile'"
            :placeholder="$lang('請輸入電話')"
            :disabled="disabled"
          />
          <b-form-invalid-feedback :state="errors.has('phone')">
            {{ errors.first("phone") }}
          </b-form-invalid-feedback>
        </b-form-group>
      </b-col>
      <b-col md="5" v-if="!disabled">
        <slot name="remove"></slot>
      </b-col>
    </b-row>
  </div>
</template>

<script>
export default {
  props: {
    index: String,
    value: {
      type: Object,
      default() {
        return {
          name: "",
          nameLang: "",
          phone: null,
          idType: "",
          idNumber: "",
          bornAt:null,
        };
      },
    },
    disabled: {
      type: Boolean,
      default: false,
    },
    rules: {
      type: Object,
    },
    requiredType: {
      type: Boolean,
    },
  },
  data() {
    return {
      // options: [
      //     { text: this.optionYes, value: true },
      //     { text: "否", value: false }]
    };
  },
  computed: {
    options() {
      return [
        { text: this.$lang("boolean.yes"), value: true },
        { text: this.$lang("boolean.no"), value: false },
      ];
    },
  },
  methods: {
    onSubmit() {
      return new Promise((resolve, reject) => {
        this.$validator.validate().then((result) => {
          resolve(result);
        });
      });
    },
    validateErrors(field, msg) {
      this.errors.add({
        field,
        msg,
      });
    },
  },
};
</script>
